<!-- --------首页-------- -->
<template>
  <div class="page">
    <!--banner-->
    <div class="mainBanner">
      <!--图片-->
      <div class="bannerImg"
           :style="{height:bannerHeight +'px'}">
        <transition-group tag="div">
          <img :src=v.url
               v-for="(v,i) in banners"
               :key="v.position"
               :style="{opacity:(i+1)==n?'1':'0'}"
               class="active">
        </transition-group>
      </div>
      <!--按钮-->
      <ul class="bannerBtn clear-fix">
        <li v-for="num in banners.length"
            :key="num">
          <span :style="{background: num == n?'#fff':''}"
                @click='changeBnaner(num)'
                class='aBtn'></span>
        </li>
      </ul>
    </div>
    <!--content-->
    <div class="content">
      <!--数字产品-->
      <div class="bg_f">
        <h2 class="title">数字产品</h2>
        <h3 class="enTitle">Digital Products</h3>
        <h3 class="subTitle">基于边缘计算网格架构的智能医学物联网芯片系统 • 助力家庭/医院移动智能检测监测</h3>
        <div class="imgShow">
          <div class="conItem animated flipInX"
               v-for="d in digitalProducts"
               :key="d.id"
               @click="toProductIntro(d.id,d.page)">
            <img :src="d.imgSrc"
                 :class="{'animated': d.isTrue, 'swing': d.isTrue}"
                 :style="d.id==1?'opacity: 0.9;':''">
            <h2>{{d.title}}</h2>
            <Button>查看更多</Button>
          </div>
        </div>
      </div>
      <!--智能数字科技-->
      <div class="bg_f2">
        <h2 class="title">智能数字科技</h2>
        <h3 class="enTitle">Intelligent digital technology</h3>
        <h3 class="subTitle">基于边缘计算网格架构的智能医学物联网芯片系统 • 助力家庭/医院移动智能检测监测</h3>
        <div class="productIntro">
          <div class="left animated fadeInLeft">
            <h3>天下医生-智能数字家庭体检医生</h3>
            <div class="line"></div>
            <p>•&nbsp;搭载「天下医森」智能医学物联网医疗级芯片系统</p>
            <p>•&nbsp;软硬一体化，手机声控引导操作</p>
            <p>•&nbsp;院内床旁移动检测：血糖、尿酸、总胆固醇</p>
            <p>•&nbsp;院外全家日常自测：血糖、尿酸、总胆固醇</p>
            <p>•&nbsp;检测结果实时上传云端保存，医生/家人随时查阅</p>
            <!--<p>•&nbsp;新四高病症多参数联动性监测，主动促进糖尿病、痛风和高血脂症系统防控</p>-->
            <p>•&nbsp;新四高病症多参数联动性监测，主动促进三高慢病系统防控</p>
            <Button @click="toMappingPage('device3&1','coreProduct')"
                    class="viewMore">查看更多</Button>
          </div>
          <div class="right animated fadeInRight">
            <img src="/static/images/home/device3&1.png">
          </div>
        </div>
      </div>
      <!--资讯动态-->
      <div class="bg_f">
        <div class="newShow">
          <div class="left">
            <div class="topImg">
              <div class="leftTitle">公司<br />动态</div>
              <div class="bottomBox">
                <div class="bottomContent"
                     @click="companyNewDetails(companyNewLists_1.id)">
                  <div class="textContent">
                    <h2>{{companyNewLists_1.title | ellipsis}}</h2>
                    <h4>{{companyNewLists_1.date | substrTime}}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottomList"
                 v-for="n in companyNewLists"
                 :key="n.id"
                 @click="companyNewDetails(n.id)">
              <div class="leftTime">
                <span class="date">{{n.date | substrMonth}}/{{n.date | substrDay}}</span><br />
                <span class="year">{{n.date | substrYear}}</span>
              </div>
              <p class="textTitle">{{n.title}}</p>
            </div>
            <Button @click="toMappingPage('company','companyNews')"
                    class="viewMore">查看更多</Button>
          </div>
          <div class="right">
            <div class="topImg">
              <div class="leftTitle">行业<br />资讯</div>
              <div class="bottomBox">
                <div class="bottomContent"
                     @click="industryNewDetails(industryNewLists_1.id)">
                  <div class="textContent">
                    <h2>{{industryNewLists_1.title | ellipsis}}</h2>
                    <h4>{{industryNewLists_1.date | substrTime}}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottomList"
                 v-for="n in industryNewLists"
                 :key="n.id"
                 @click="industryNewDetails(n.id)">
              <div class="leftTime">
                <span class="date">{{n.date | substrMonth}}/{{n.date | substrDay}}</span><br />
                <span class="year">{{n.date | substrYear}}</span>
              </div>
              <p class="textTitle">{{n.title}}</p>
            </div>
            <Button @click="toMappingPage('industry','industryNews')"
                    class="viewMore">查看更多</Button>
          </div>
        </div>
      </div>
      <!--战略合作伙伴-->
      <div class="bg_f2">
        <h2 class="title">战略合作伙伴</h2>
        <h3 class="enTitle">Partners</h3>
        <h3 class="subTitle">秉承「包容开放、创新示范、合作共享」精神，与合作伙伴共同致力于为用户和社会创造更大的健康价值</h3>
        <div class="iconShow">
          <div class="item"
               :key="p.id"
               v-for="p in partnerImg">
            <img :src="p.pImg">
          </div>
        </div>
      </div>
      <!--数字健康网络-->
      <div class="bg_f mapBg">
        <h2 class="title">数字健康网络</h2>
        <h3 class="enTitle">Digital Health Network</h3>
        <p>已创建分布全国<span>20</span>多个省区，线上线下融合的数字主动健康服务协同网络</p>
<!--        <div class="mapImg">-->
<!--          <img src="/static/images/home/mapImg.png"-->
<!--               alt="map">-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data () {
    return {
      banners: [],
      n: 1,　　　　　　　  //图片index
      bFlag: true,      //锁定
      timer1: '',　　　　//bFlag定时器的数据
      timer2: '',　　　　//自动播放next()定时器的数据
      timer3: '',　　　　//打开浏览器时，初始运动定时器的数据
      bannerHeight: 0,
      digitalProducts: [
        { id: 1, imgSrc: '/static/images/home/home_sz5.png', title: '沃慧管', page: 'memberButler', isTrue: false },
        { id: 2, imgSrc: '/static/images/home/home_sz1.png', title: '单病种数字主动健康服务', page: 'expertTeam', isTrue: false },
        { id: 3, imgSrc: '/static/images/home/home_sz2.png', title: '数字家庭医生签约服务', page: 'familyDoctor', isTrue: false },
        { id: 4, imgSrc: '/static/images/home/home_sz3.png', title: '智能数字化医院服务', page: 'doctorApp', isTrue: false },
        { id: 5, imgSrc: '/static/images/home/home_sz4.png', title: '病种数字健康科技产品', page: 'coreProduct', isTrue: false },
      ],
      partnerImg: [
        { id: 1, pImg: '/static/images/home/home_p1.png' },
        { id: 2, pImg: '/static/images/home/home_p2.png' },
        { id: 3, pImg: '/static/images/home/home_p3.png' },
        { id: 4, pImg: '/static/images/home/home_p4.png' },
        { id: 5, pImg: '/static/images/home/home_p5.png' },
        { id: 6, pImg: '/static/images/home/home_p6.png' },
        { id: 7, pImg: '/static/images/home/home_p7.png' },
        { id: 8, pImg: '/static/images/home/home_p8.png' },
        { id: 9, pImg: '/static/images/home/home_p9.png' },
        { id: 10, pImg: '/static/images/home/home_p10.png' }
      ],
      companyNewLists: [],
      companyNewLists_1: {},
      industryNewLists: [],
      industryNewLists_1: {},
      tempList_gs: [],
      tempList_hy: [],
      currentPage: 1,
      totals_gs: 0,
      totals_hy: 0,
      pageSize: 3
    }
  },
  filters: {
    /*先暂时这么写吧*/
    ellipsis (value) {
      if (!value) return '';
      if (value.length > 8) {
        return value.slice(0, 23) + '...';
      }
      return value;
    },
    substrYear (value) {
      if (!value) return '';
      value = value.slice(0, 4);
      return value;
    },
    substrMonth (value) {
      if (!value) return '';
      value = value.slice(5, 7);
      return value;
    },
    substrDay (value) {
      if (!value) return '';
      value = value.slice(8, 10);
      return value;
    },
    substrTime (value) {
      if (!value) return '';
      value = value.slice(0, 10);
      return value;
    }
  },
  mounted () {
    let _this = this;
    /*banner高度*/
    this.getBanner()


    /*新闻列表数据*/
    let newData = this.currUrl.companyNews + '?page=' + this.currentPage + '&size=' + this.pageSize;
    this.$http.all([
      this.$http.get(newData + '&type=1'),
      this.$http.get(newData + '&type=2')
    ]).then(this.$http.spread(function (companyNewData, industryNewData) {
      _this.companyNewLists_1 = companyNewData.data.data.data[4];
      _this.industryNewLists_1 = industryNewData.data.data.data[4];

      _this.tempList_gs = companyNewData.data.data.data;
      _this.totals_gs = companyNewData.data.data.totalSize;

      _this.tempList_hy = industryNewData.data.data.data;
      _this.totals_hy = industryNewData.data.data.totalSize;

      if (_this.totals_gs < _this.pageSize || _this.totals_hy < _this.pageSize) {
        _this.companyNewLists = _this.tempList_gs;
        _this.industryNewLists = _this.tempList_hy;
      } else {
        _this.companyNewLists = _this.tempList_gs.slice(0, _this.pageSize);
        _this.industryNewLists = _this.tempList_hy.slice(0, _this.pageSize);
      }
    }));

  },
  methods: {
    async getBanner () {
      const { data: res } = await this.$http.post(this.currUrl.queryBanner, {
        port: 6, // 官网
        positionType: 7, // 首页轮播
      })
      console.log(res)
      if (res.code === '200') {
        this.banners = res.object
        if (document.body.clientWidth > 768) {
          this.bannerHeight = (680 / 1920) * document.body.clientWidth;
          // this.banners = [
          //   '/static/images/home/homeBanner_1.png',
          //   '/static/images/home/homeBanner_2.png',
          //   '/static/images/home/homeBanner_3.png'
          // ];
        } else {
          this.bannerHeight = (375 / 680) * document.body.clientWidth;

          /* this.banners = [
            { position: 1, url: '/static/images/home/homeBanner_1p.png' },
            { position: 2, url: '/static/images/home/homeBanner_2p.png' },
            { position: 3, url: '/static/images/home/homeBanner_3p.png' },
          ] */
        }
        /*banner渐隐渐现*/
        this.timer3 = setTimeout(this.next, 5200);
      } else {

      }
    },
    toProductIntro (id, page) {
      // console.log(id,page,this.digitalProducts)
      this.$router.push({ name: page });
      // this.digitalProducts.forEach(item => {
      //   if(id == item.id){
      //     item.isTrue = true;
      //       this.$router.push({name: page});
      //   }
      // });
      // this.$router.go(0);
    },
    toMappingPage (type, path) {
      if (type == 'device3&1' || type == 'company' || type == 'industry') {
        this.$router.push({ name: path });
      }
      this.$router.go(0);
    },
    companyNewDetails (id) {
      this.$router.push({ name: 'companyNewDetails', params: { id: id } });
    },
    industryNewDetails (id) {
      this.$router.push({ name: 'industryNewDetails', params: { id: id } });
    },
    /*banner部分*/
    next () {
      if (this.bFlag) {
        this.bFlag = false;
        this.clearT();　　　　　　　　　         // 运动之前，清除所有定时器。
        this.n = this.n + 1 == 4 ? 1 : this.n + 1;　  // 下一张，如果是第4张，就返回第一张。
        this.timeout();                      // 调用timeout函数，延迟进入下一次轮播，以便可以点击切换。
      }
    },
    clearT () { // 清除所有定时器　　　　　　　　　　　　　　　
      clearTimeout(this.timer1);
      clearTimeout(this.timer2);
      clearTimeout(this.timer3);
    },
    timeout () {
      this.timer2 = setTimeout(() => {
        this.bFlag = true;
      }, 1000);
      this.timer1 = setTimeout(() => {
        this.next();
      }, 5200);
    },
    changeBnaner (num) {
      if (this.bFlag) {
        this.bFlag = false;
        this.clearT();
        this.n = num;
        this.timeout();
      }
    }
  }
}
</script>

<style lang="scss"  scoped>
</style>



// WEBPACK FOOTER //
// src/components/home.vue